<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新建'"
      width="800px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="序列号" prop="serialNo">
            <el-input v-model.trim="model.serialNo" placeholder="请输入序列号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="批次号">
            <el-input v-model.trim="model.batchNo" placeholder="请输入批次号"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="类型">
            <el-select v-model="model.serialNoType" clearable placeholder="请选择类型" style="width: 100%">
              <el-option label="产品条码" :value="10"/>
              <el-option label="外包装条码" :value="20"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料编号" prop="materialNo">
            <el-input v-model.trim="model.materialNo" placeholder="请输入物料编号"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="关联单号">
            <el-input v-model.trim="model.refBillNo" placeholder="请输入关联单号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联单行号">
            <el-input v-model.trim="model.refBillRowNo" placeholder="请输入关联单行号"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="机种代码">
            <el-input v-model.trim="model.productCode" placeholder="请输入机种代码"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态">
            <el-input v-model.trim="model.status" placeholder="请输入状态"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "SnSerialManageEdit",
    components: {},
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        model: {
          pkid: "",
          serialNo: "",
          batchNo: "",
          serialNoType: "",
          materialNo: "",
          refBillNo: "",
          refBillRowNo: "",
          productCode: "",
          status: "",
          isOldSn: false,
        },
        ruleValidate: {
          serialNo: { required: true, message: "序列号不能为空", trigger: "blur" },
          materialNo: { required: true, message: "物料编号不能为空", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          this.getData(row.pkid);
        } else {
          this.model = {
            pkid: "",
            serialNo: "",
            batchNo: "",
            serialNoType: "",
            materialNo: "",
            refBillNo: "",
            refBillRowNo: "",
            productCode: "",
            status: "",
            isOldSn: false,
          };
        }
      },
      getData(pkid) {
        this.contentLoading = true;
        this.$http.get("basic", `snSerialNos/${pkid}`).then((res) => {
          this.contentLoading = false;
          if (res.success) {
            this.model = Object.assign(this.model, res.data);
          }
        });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            if (this.model.pkid) {
              // 编辑：PUT snSerialNos/{id}，以实体字段为准保存
              this.$http.put("basic", `snSerialNos/${this.model.pkid}`, this.model)
                .then((resp) => {
                  this.submitLoading = false;
                  if (resp.success) {
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  }
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              // 新增：POST snSerialNos，以实体字段为准保存
              this.$http.post("basic", "snSerialNos", this.model)
                .then((resp) => {
                  this.submitLoading = false;
                  if (resp.success) {
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  }
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
